<script>
/* eslint-disable object-shorthand */
import { assign, get } from 'lodash';
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import RedirectLogged from 'components/mixins/redirect-logged';

import FormLogin from './form-login';

export default {
  name: 'page-login',
  mixins: [
    PageProps,
    RedirectLogged,
  ],
  props: {
    redirect: {
      type: String,
      required: false,
      default: null,
    },
    token: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    FormLogin,
  },
  data() {
    return {
      error: null,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    RegionalAndLanguageAll() {
      return this.$store.getters.RegionalAndLanguageAll;
    },
    loading() {
      return this.RegionalAndLanguageAll.fetching;
    },
  },
  methods: {
    ...mapActions([
      'AuthenticateLogin',
      'PreLoginPersonalProfile',
    ]),
    onChangeLanguage(value) {
      this.$locale.change(value);
    },
    onSubmit(data) {
      this.$auth.login({
        url: '/auth/login',
        data: data.payload,
        rememberMe: data.rememberMe,
        fetchUser: true,
        success() {
          this.redirectLogin(this.redirect);
        },
        error(error) {
          console.log('error rrrr', error, error.toString());
          this.error = assign({}, { error: error.data || error.toString() });
        },
      });
    },
    onEmailChange(email) {
      this.PreLoginPersonalProfile({ email });
    },
  },
  created() {
    this.$store.dispatch('GetRegionalAndLanguageAll', { language_app_support: true });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearRegionalAndLanguageAll');
  },
  watch: {
    PersonalProfile: {
      handler: function (value) {
        const locale = get(value, 'data.preferred_language');
        if (locale) this.$locale.change(locale);
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/login/page-login.vue